import React from "react";
import {Arrow} from "BaseComponents/Icons/Svg";
import {BreadcrumbsLink} from "./BreadcrumbsLink";
import {BreadcrumbsLinkContainer} from "./BreadcrumbsLinkContainer";
import {BreadcrumbsWrapper} from "./BreadcrumbsWrapper";
import useBreakpoint from "Hooks/useBreakpoint";
import {useGlobal} from "reactn";

export const Breadcrumbs = ({Items, bgColor}) => {
    const [theme] = useGlobal("theme");

    return Items && Items.length > 0 ? (
        <BreadcrumbsWrapper
            bgColor={bgColor}
            smallpadding="1rem 1rem"
            mobilepadding="1rem 1rem 1rem 1rem"
            smallwidth="unset"
            width="unset"
            padding="1rem 3rem"
        >
            <BreadcrumbsWrapper
                maxWidth="1280px"
                smallpadding="0 0 0 1rem"
                mobilepadding="0"
                padding="0 1rem"
                smallwidth="unset"
                width="unset"
                smallAlignContent="center"
                alignItems="center"
                smallrow={true}
                column={false}
            >
                {Items.length > 0 &&
                    Items.map((page, i) => {
                        let last = i + 1 == Items.length;
                        let lastMobile = i + 2 == Items.length;
                        let first = i == 0;
                        return (
                            <BreadcrumbsLinkContainer
                                key={`breadcrumbs-${i}`}
                                show={lastMobile}
                                first={first}
                            >
                                {useBreakpoint("mobile") && (
                                    <Arrow
                                        color={theme.colors.primary}
                                        invert="rotate(180deg)"
                                        size="15px"
                                        display="none"
                                        margin="0 2px 0 0"
                                        smalldisplay="block"
                                    />
                                )}
                                <BreadcrumbsLink
                                    href={page.PageUrl}
                                    text={page.PageName}
                                    last={last}
                                    first={first}
                                    mobile={useBreakpoint("mobile")}
                                ></BreadcrumbsLink>

                                {!useBreakpoint("mobile") && (!last || first) && (
                                    <Arrow size="5px" color={theme.colors.primary}/>
                                )}
                            </BreadcrumbsLinkContainer>
                        );
                    })}
            </BreadcrumbsWrapper>
        </BreadcrumbsWrapper>
    ) : (
        <></>
    );
};
